import React from 'react';
import Button from '@material-ui/core/Button';

const Footer = () => {
    return (
      <footer className="app-footer">
        <span className="d-inline-block">Copyright &copy; 2016 <a href='https://www.ismartsales.com' target='_blank'>ICM Smart Solution Co.,Ltd.</a> Version 6.0.2</span>
        <Button
          href=""
          target="_blank"
          size="small"
          color="primary"
        >Web</Button>
      </footer>
    );
  }
;

export default Footer;